export const dashboardForRole = (role) => {
    switch (role) {
        case 'SUPER_ADMIN': return '/super-admin';
        case 'ADMIN': return '/admin';
        case 'SUPER_USER': return '/super-user';
        case 'USER': return '/user';
        case 'GUEST': return '/guest';
        default: return '/login';
    }
};
